/* Promotion diagnostics. Commerce events remain owned by Shopify. */
(() => {
  'use strict';
  if (window.SpotmatePromotionTracking) return;
  const containerId = 'GTM-MZ86MWW4';
  let containerStarted = false;
  function startContainer() {
    if (containerStarted || !allowed()) return;
    containerStarted = true;
    window.spotmateGtmLayer = window.spotmateGtmLayer || [];
    window.spotmateGtmLayer.push({'gtm.start': Date.now(), event: 'gtm.js'});
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtm.js?id=' + containerId + '&l=spotmateGtmLayer';
    document.head.appendChild(script);
  }
  const formId = 'V7YHFZ';
  const fields = ['form_id', 'form_action', 'step_number', 'bundle_id', 'bundle_mode',
    'section_id', 'item_count', 'product_id', 'variant_id', 'error_type'];
  function allowed() {
    try {
      return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true &&
        !window.Shopify?.designMode && window.Shopify?.theme?.role === 'main';
    } catch (_) { return false; }
  }
  function emit(name, values = {}) {
    try {
      if (!allowed() || !/^sm_(wheel|bundle)_[a-z_]+$/.test(name)) return false;
      const data = {};
      fields.forEach(key => {
        const value = values[key];
        if (typeof value === 'number' && Number.isFinite(value)) data[key] = value;
        if (typeof value === 'string' && /^[a-zA-Z0-9_:.\-]{1,100}$/.test(value)) data[key] = value;
      });
      startContainer();
      window.spotmateGtmLayer.push({promotion: null});
      window.spotmateGtmLayer.push({event: 'sm_promotion', promotion: {name, parameters: data}});
      return true;
    } catch (_) { return false; }
  }
  window.SpotmatePromotionTracking = {emit};
  document.addEventListener('visitorConsentCollected', startContainer);
  window.addEventListener('load', startContainer);
  startContainer();
  let step = 0;
  let submitted = false;
  window.addEventListener('klaviyoForms', event => {
    const detail = event.detail || {};
    if (detail.formId !== formId) return;
    const names = {open: 'open', close: 'close', submit: 'submit',
      stepSubmit: 'step_submit', redirectedToUrl: 'redirect'};
    const action = names[detail.type];
    if (!action) return;
    if (action === 'open') step = 0;
    if (action === 'submit' && submitted) return;
    if (action === 'step_submit') step += 1;
    const sent = emit('sm_wheel_' + action, {form_id: formId, form_action: action, step_number: step});
    if (action === 'submit' && sent) submitted = true;
  });
  // Count actual visible module exposure, once per mounted section after consent.
  const observed = new WeakSet();
  const visible = new Set();
  const observer = typeof IntersectionObserver === 'function' ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting || entry.intersectionRatio < 0.1) { visible.delete(entry.target); return; }
      visible.add(entry.target);
      expose(entry.target);
    });
  }, {threshold: 0.1}) : null;
  function expose(element) {
    const sectionId = element.id || element.closest('[id^="shopify-section-"]')?.id?.replace(/^shopify-section-/, '') || 'bundle_module';
    if (emit('sm_bundle_view', {section_id: sectionId})) {
      observer?.unobserve(element);
      visible.delete(element);
    }
  }
  function scan() {
    document.querySelectorAll('[x-data^="xBuyOwnBundle("]').forEach(element => {
      if (!observer || observed.has(element)) return;
      observed.add(element);
      observer.observe(element);
    });
  }
  document.addEventListener('visitorConsentCollected', () => visible.forEach(expose));
  document.addEventListener('shopify:section:load', scan);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, {once: true});
  else scan();
})();
